export default __webpack_public_path__ + "assets/526e7279816a109ecb6c9d84248332a4.jpeg";